import { useSelector } from "react-redux";
import { selectUserProfile } from "../redux/selectors/user";

const useUserConfig = () => {
  const user = useSelector(selectUserProfile);
  const { permissions } = user ?? { permissions: [] };

  const hasPermission = (permissionKey) => permissions.includes(permissionKey);

  return hasPermission;
};

export default useUserConfig;
